module.exports = __webpack_public_path__ + "img/_design.393857bf.svg";